<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-10-24 14:02:55
 * @LastEditTime: 2021-10-28 13:54:44
 * @LastEditors: chenguobiao
-->
<template>
  <div class="grading-count-down">
    <div class="times">
      {{times}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('grading', ['totalTime']),
    times() {
      const m = parseInt(this.totalTime / 60)
      const s = this.totalTime - m * 60
      return `${m}分${s}秒`
    }
  }
}
</script>

<style lang="scss">
  .grading-count-down {
    margin-right: val(44);
    display: flex;
    align-items: center;
    .times {
      font-size: val(20);
      color: #DCAD81;
    }
  }
</style>